import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import DOMPurify from "dompurify";

function CategorySlider({
  categoryName,
  categoryUrl,
  relatedSubCategories,
  backurl,
}) {
  const subCategorySliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="row">
      <div className="col-lg-12 mb-30">
        <h3 className="text-center">
          Explore Sub Categories Under {categoryName}
        </h3>
      </div>

      <div className="col-lg-12">
        <Slider {...subCategorySliderSettings}>
          {relatedSubCategories.map((sub) => {
            let foldername = sub.category_name
              .replaceAll(" ", "_")
              .toLowerCase();
            return (
              <div key={sub.id} className="px-15">
                <div className="prt-featured-box text-center p-25 border-rad_20 h-100">
                  <img
                    src={`${backurl}shop_sub_category/${foldername}/${sub.category_images.split("|")[0]}_large.webp`}
                    alt={sub.category_name}
                    className="img-fluid mb-15 rounded"
                  />

                  <h5 className="mb-10">{sub.category_name}</h5>

                  <p
                    className="mb-15"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(sub.short_description || ""),
                    }}
                  ></p>

                  <Link
                    to={`${categoryUrl}${sub.category_url}`}
                    className="prt-btn prt-btn-size-sm prt-btn-style-border"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}

export default CategorySlider;
